/** Namespace i18n u3130 — évite les imports circulaires avec `U3130.tsx`. */
export const U3130_NS = "u3130";
